import { Component, Input, OnInit } from '@angular/core';
import { SettingsService } from '../../../services/settings.service';
import { Observable } from 'rxjs';
import { AlphaPrefixConfig } from '@interfaces/alpha-prefix-config.model';
import { TrackByUtilities } from '../../../utilities/trackByFn.utilities';
import { CcssService } from '@services/ccss/ccss.service';
import { ProductAnalyticsService } from '@services/product-analytics/product-analytics.service';

@Component({
  selector: 'app-login-prompt',
  templateUrl: './login-prompt.component.html',
  styleUrls: ['./login-prompt.component.scss'],
})
export class LoginPromptComponent implements OnInit {
  @Input() margin: string;
  @Input() loginUrl: string;

  public alphaPrefix: Observable<AlphaPrefixConfig>;
  public trackByFn: any = TrackByUtilities.trackByFnIndex;

  constructor(
    public ccss: CcssService,
    public productAnalyticsService: ProductAnalyticsService,
    private settingsService: SettingsService
  ) {}

  ngOnInit() {
    this.alphaPrefix = this.settingsService.getSetting(
      'alpha_prefix',
      AlphaPrefixConfig
    );
  }

  public arrayOf(length: number): number[] {
    return Array(length);
  }
}
